var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "txt"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29218",
    "data-name": "Rectangle 29218",
    width: 50,
    height: 50,
    transform: "translate(843 433)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_643",
    "data-name": "Mask Group 643",
    transform: "translate(-843 -433)",
    clipPath: "url(#txt)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_79_",
    "data-name": "svgexport-6 (79)",
    transform: "translate(849.19 433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11474",
    "data-name": "Group 11474",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_29_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11515",
    "data-name": "Path 11515",
    d: "M14.2,0H30.644L44.565,14.516V42.745a6.4,6.4,0,0,1-6.4,6.389H14.2a6.393,6.393,0,0,1-6.389-6.389V6.389A6.393,6.393,0,0,1,14.2,0Z",
    transform: "translate(-7.811)",
    fill: "#0263d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11473",
    "data-name": "Group 11473",
    transform: "translate(10.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11516",
    "data-name": "Path 11516",
    d: "M36.6,0V14.4h13.94Z",
    transform: "translate(-24.597)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11517",
    "data-name": "Path 11517",
    d: "M35.5,31.694H22.541a1.077,1.077,0,1,1,0-2.155H35.5a1.077,1.077,0,0,1,0,2.155ZM31.178,44.651H22.541a1.077,1.077,0,1,1,0-2.155h8.638a1.077,1.077,0,1,1,0,2.155ZM35.5,40.332H22.541a1.077,1.077,0,1,1,0-2.155H35.5a1.077,1.077,0,1,1,0,2.155Zm0-4.319H22.541a1.077,1.077,0,1,1,0-2.155H35.5a1.077,1.077,0,0,1,0,2.155Z",
    transform: "translate(-21.454 -6.13)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.a746b14deea80453548b336c63afc981.svg";
export { ForwardRef as ReactComponent };